/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerGetDownloadUrlQueryResponse, DocumentsControllerGetDownloadUrlPathParams, DocumentsControllerGetDownloadUrlQueryParams } from "../../models/documentsController/DocumentsControllerGetDownloadUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerGetDownloadUrl } from "../../clients/documentsService/documentsControllerGetDownloadUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerGetDownloadUrlQueryKey = (id: DocumentsControllerGetDownloadUrlPathParams["id"], params: DocumentsControllerGetDownloadUrlQueryParams = {}) => [{
  url: '/api/v1/documents/:id/download-url',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type DocumentsControllerGetDownloadUrlQueryKey = ReturnType<typeof documentsControllerGetDownloadUrlQueryKey>;
export function documentsControllerGetDownloadUrlQueryOptions(id: DocumentsControllerGetDownloadUrlPathParams["id"], params?: DocumentsControllerGetDownloadUrlQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerGetDownloadUrlQueryKey(id, params);
  return queryOptions<DocumentsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<Error>, DocumentsControllerGetDownloadUrlQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerGetDownloadUrl(id, params, config);
    }
  });
}

/**
 * @description Generates a presigned URL for direct S3 download of the document PDF. Uses the document storageLocation to find the file. Set inline=true to display in browser instead of forcing download.
 * @summary Get presigned download URL for a document
 * {@link /api/v1/documents/:id/download-url}
 */
export function useDocumentsControllerGetDownloadUrl<TData = DocumentsControllerGetDownloadUrlQueryResponse, TQueryData = DocumentsControllerGetDownloadUrlQueryResponse, TQueryKey extends QueryKey = DocumentsControllerGetDownloadUrlQueryKey>(id: DocumentsControllerGetDownloadUrlPathParams["id"], params?: DocumentsControllerGetDownloadUrlQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerGetDownloadUrlQueryKey(id, params);
  const query = useQuery({
    ...documentsControllerGetDownloadUrlQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}